<template>
  <div>
    <div class="prestorage_page" v-if="!payModel.payStatus">
      <div class="title_box flex_center">
        <img src="./image/order_icon3.png" class="order_icon" />
        <div class="flex_column">
          <div class="order_title">线上支付</div>
          <div class="order_subtitle"></div>
        </div>
      </div>
      <!-- <div class="content_box">
        <el-input
          placeholder="请输入预存金额"
          v-model="form.money"
          size="small"
          style="width: 300px"
        >
          <span class="input_icon" slot="prefix">￥</span>
          <span class="input_icon" slot="suffix">CNY</span>
          <el-button
            slot="append"
            size="small"
            class="btn_style"
            style="height: 32px"
            @click="toPay"
            >充值</el-button
          >
        </el-input>
        <br />
        <span class="order_subtitle"
          >请注意：线上支付每笔金额需小于10,000元！</span
        >
      </div>
      <div class="line_box margin20"></div> -->
      <div class="title_box flex_center">
        <img src="./image/order_icon3.png" class="order_icon" />
        <div class="flex_column">
          <div class="order_title">银行转账 (不限金额)</div>
          <div class="order_subtitle"></div>
        </div>
      </div>
      <div class="content_box font14">
        <div>
          你可以 扫码支付，然后
          <span class="bold"
            >联系专属客服、我司财务为您处理入账，感谢您的支持与谅解！</span
          >
        </div>
        <div>
          财务QQ：
          <span class="bold">{{ financialQQ }}</span>
        </div>
        <div>账户名称：<span class="bold">广州方和纸品有限公司 </span></div>
        <div>云闪付收银台：<span class="bold">账号：QRA58185311QSIC</span></div>

        <img src="./image/payQrcode.png" alt="" style="width: 400px;margin: 12px" />
      </div>
    </div>
    <div v-else class="prestorage_page">
      <div class="title_box flex_center">
        <img src="./image/order_icon3.png" class="order_icon" />
        <div class="flex_column">
          <div class="order_title">线上支付</div>
          <div class="order_subtitle"></div>
        </div>
      </div>
      <div class="flex">
        <el-card style="width: 400px;margin-left: 200px">
          <img src="payModel.payUrl" alt="" class="code_phone" />
          <div class="title">本次预存金额{{ form.money }}元</div>
          <div class="subtitle">请扫码完成支付</div>
        </el-card>
        <img src="../../assets/img/code_phone.png" class="code_phone" />
      </div>
    </div>
  </div>
</template>

<script>
import { onlinePayApi, onlinePayCheckApi, getSettingApi, } from "../../api/index";
export default {
  data() {
    return {
      form: {
        money: "",
      },
      payModel: {
        flag: false,
        payUrl: "", //支付二维码
        orderNo: "", //订单号
        payStatus: false,
      },
      financialQQ: ""
    };
  },
  created() {},
  activated() {},
  mounted() {
    this.getSetting()
  },

  methods: {
    getSetting() {
      getSettingApi().then((res) => {
        if (res.resultStatus) {
          const result = res.resultData;
          this.financialQQ = result.financialQQ ? result.financialQQ : "";
        }
      });
    },
    toPay() {
      if (Number(this.form.money) > 10000) {
        this.$message.warning("最大金额不可大于10000元");
        return;
      }
      onlinePayApi({
        rechargePrice: Number(this.form.money) ? Number(this.form.money) : 0,
      }).then((res) => {
        if (res.resultStatus) {
          if (res.resultData.payUrl) {
            this.payModel = {
              flag: true,
              payUrl: res.resultData.payUrl, //支付二维码
              orderNo: res.resultData.orderNo, //订单号
              payStatus: false,
            };
            this.checkPay();
          }
        }
      });
    },
    checkPay() {
      onlinePayCheckApi({
        orderNo: this.payModel.orderNo,
      })
        .then((res) => {
          if (res.resultStatus && res.resultData.payStatus) {
            this.$message.success("订单支付成功");
            this.payModel.payStatus = false;
          }
        })
        .finally(() => {
          if (!this.payModel.payStatus) {
            setTimeout(() => {
              this.checkPay();
            }, 1000);
          }
        });
    },
    submitForm() {},
  },
};
</script>

<style lang="less">
.prestorage_page {
  width: 100%;
  min-height: 100%;
  border: 1px solid #e1e1e1;
  padding: 20px;
  box-sizing: border-box;
  .title_box {
    margin-bottom: 12px;
  }
  .width200 {
    width: 200px;
  }
  .width150 {
    width: 150px;
  }
  .content_box {
    width: 100%;
    box-sizing: border-box;
    .table_content {
      width: 100%;
      box-sizing: border-box;
    }
    .statics {
      font-size: 14px;
      font-weight: bold;
      margin-top: 12px;
    }
  }
  .line_box {
    width: 100%;
    height: 1px;
    background: #999;
  }
  .font14 {
    font-size: 14px;
    color: rgb(136, 136, 136);
  }
  .text {
    margin-top: 10px;
  }
  .bold {
    font-weight: bold;
  }
  .code_phone {
    width: 400px;
  }
  .title {
    font-size: 16px;
  }
  .subtitle {
    font-size: 13px;
    color: #333;
    margin-top: 12px;
  }
}
.margin20 {
  margin: 20px 0;
}
.input_icon {
  line-height: 32px;
}
.el-tabs__item {
  color: #999;
}
.el-tabs__item:hover {
  color: #00a0e9;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border: 1px solid #2f4050;
  border-bottom: 0;
}
.el-tabs__item.is-active {
  color: #000000;
}
</style>